module.exports = __webpack_public_path__ + "img/slide3.35123fee.webp";